export function notification (state) {
  return state.notification
}

export function title (state) {
  return state.title
}
